import styled from 'styled-components';

export const Wrap = styled.header`
  height: 60px;
  background-color: #20232a;
  user-select: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
`

export const FrontWrap = styled.div`
  display: inline-block;
  line-height: 60px;

  @media screen and (min-width: 1400px) {
    position: relative;
    float: left;
  }
`

export const Logo = styled.a`
  display: inline-block;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;

  > svg {
    position: absolute;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media screen and (max-width: 1399px) {
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;    
  }
`

export const Name = styled.a`
  display: inline-block;
  height: 60px;
  padding-left: 60px;
  color: #fff;
  font-size: 12px;
  line-height: 58px;

  &:hover {
    color: #61DAFB;
  }

  @media screen and (max-width: 1399px) {
    padding-left: 20px;
    z-index: 10;
  }
` 

export const Logout = styled.a`
  display: inline-block;
  width: 30px;
  height: 13px;
  margin-left: 10px;
  color: #fff;
  position: relative;

  > svg {
    stroke: #fff;
    position: absolute;
    top: 0px;

    &:hover {
      stroke: #61DAFB;
    }
  }

  @media screen and (max-width: 1399px) {
    display: none;
  }
`


export const Arrows = styled.div`
  display: inline-block;
  height: 60px;

  > button {
    width: 25px;
    height: 60px;
    border: 0;
    outline: none;
    background-color: transparent;
  }

  @media screen and (min-width: 1400px) {
    position: relative;
  }

  @media screen and (max-width: 1399px) {
    float: left;
    margin-left: 10px;
  }
`


export const Nav = styled.nav`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;

  > div {
    display: none;
  }

  @media screen and (min-width: 1400px) {
    left: ${props => props.user_type === '_agency' ? '250px' : '250px'};
  }

  @media screen and (max-width: 1399px) {
    ${props => props.isOpen ? `width: 100%;` : ``}
    z-index: 0;

    > ul {
      display: ${props => props.isOpen ? 'block' : 'none'};
    }
  
    > div.MenuBtn {
      display: block;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);

      > div {
        width: 46px;
        height: 43px;
        padding: 8px 7px;
        box-sizing: border-box;
        border: 2px solid #d1d1d1;
        border-radius: 4px;
        cursor: pointer;

        > .Bar {
          width: 100%;
          height: 3px;
          background-color: #d1d1d1;
          border-radius: 3px;

          & + p {
            margin-top: 7px;
          }
        }
      }
    }
  }
`

export const MenuWrap = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 50;

  @media screen and (max-width: 1399px) {
    width: 100%;
    height: ${props => props.height}px;
    border-top: 1px solid #61DAFB;
    background-color: #20232a;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    top: 60px;
  }
`



// WEBPACK FOOTER //
// ./client/components/Header/styled.js